module.exports = __webpack_public_path__ + "media/icons/extras--on-demand-f28e1182.svg";